module.exports = __webpack_public_path__ + "img/public/TrustIcons/VeriffTrustIcon.png?9c0e51b3";